
import { IMarker } from "redux/utils/interfaces";
import { reduxActionType, stationsReducerType } from "redux/utils/types";

const initialState = {
	stations: [] as IMarker[],
	stationId: "" as string,
	stationIndex: 0 as number,
};

export const pageNameReducer = (
	state = {PageName: "" as string},
	action: reduxActionType
):any => {
	switch (action.type) {
		case "setPageName": {
			return {PageName: action.payload};
		}
		default:
			return state;
		}
}

export const anaChartReducer = (
	state = {shouldRefresh: false as boolean},
	action: reduxActionType
):any => {
	switch (action.type) {
		case "setShouldRefresh": {
			return {shouldRefresh: action.payload};
		}
		default:
			return state;
		}
}
